import React from 'react';
import { useNavigate } from 'react-router-dom';

const NewChatButton: React.FC = () => {
  const navigate = useNavigate();

  const handleNewChat = () => {
    window.location.href = '/chat/new';
  };

  return (
    <button
      onClick={handleNewChat}
      className="px-4 py-2 rounded-lg flex items-center gap-2 hover:opacity-90 transition-opacity"
      style={{ 
        backgroundColor: 'var(--rhea-accent-primary)',
        color: 'var(--rhea-text-primary)'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
      New Chat
    </button>
  );
};

export default NewChatButton; 